<template>
  <InputComponent :label="$t('billing')" class="billing">
    <template #default>
      <component :is="component" :value="value" v-bind="$attrs" @input="$ev => $emit('input', $ev)" />
    </template>
    <template #after-label>
      <a @click.prevent="toggle" class="billing__edit">{{ $t(edit ? 'cancel' : 'edit') }}</a>
    </template>
  </InputComponent>
</template>

<script>
import ViewComponent from './View.vue'
import MutateComponent from './Mutate.vue'
import { InputComponent } from 'vue-elder-input'
import Billing from '@/models/Billing'

export default {
  data() {
    return {
      edit: false,
    }
  },
  props: {
    value: Object,
  },
  computed: {
    component() {
      if (this.edit) return MutateComponent
      return ViewComponent
    },
  },
  methods: {
    toggle() {
      let newState = !this.edit
      this.$emit('input', newState ? Billing(this.$store.state.enums.ClientDetails) : null)
      this.edit = newState
    },
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss">
.billing {
  &__edit {
    margin-left: auto;
  }
}
</style>
